export default function Terms() {
  return (
    <div style={{ maxWidth: 900, margin: "40px auto", padding: 20 }}>
      <h1>Terms & Conditions</h1>

      <p>
        For the purpose of these Terms and Conditions, “we”, “us”, “our” refers to
        ORIVON TECHNOLOGIES, whose registered office is Thane, Maharashtra – 400607.
      </p>

      <p>
        “You”, “user”, “visitor” refers to any person accessing or purchasing
        from our website.
      </p>

      <p>
        The content of the website is subject to change without notice. We do not
        guarantee accuracy, completeness, or suitability of information.
      </p>

      <p>
        Your use of any information or materials is entirely at your own risk.
        It is your responsibility to ensure services meet your requirements.
      </p>

      <p>
        All website material including design, layout, graphics, and content is
        owned by or licensed to us. Unauthorized reproduction is prohibited.
      </p>

      <p>
        Unauthorized use may give rise to a claim for damages and/or be a criminal
        offense.
      </p>

      <p>
        Our website may contain links to third-party websites for convenience.
        We are not responsible for their content.
      </p>

      <p>
        Any disputes shall be governed by the laws of India.
      </p>

      <p>
        We shall not be liable for any loss arising from transaction failures due
        to card limits or bank authorization issues.
      </p>
    </div>
  );
}
